var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3906 2.5C14.3906 1.57031 15.1562 0.75 16.1406 0.75H23.0859C23.3594 0.75 23.5781 0.804688 23.7969 0.914062C23.9609 0.96875 24.1797 1.13281 24.3438 1.29688C24.6719 1.625 24.8359 2.0625 24.8906 2.5V9.5C24.8906 10.4844 24.0703 11.25 23.1406 11.25C22.1562 11.25 21.3906 10.4844 21.3906 9.5V6.76562L12.0938 16.0078C11.4375 16.7188 10.2891 16.7188 9.63281 16.0078C8.92188 15.3516 8.92188 14.2031 9.63281 13.5469L18.875 4.25H16.1406C15.1562 4.25 14.3906 3.48438 14.3906 2.5ZM0.390625 6C0.390625 4.08594 1.92188 2.5 3.89062 2.5H9.14062C10.0703 2.5 10.8906 3.32031 10.8906 4.25C10.8906 5.23438 10.0703 6 9.14062 6H3.89062V21.75H19.6406V16.5C19.6406 15.5703 20.4062 14.75 21.3906 14.75C22.3203 14.75 23.1406 15.5703 23.1406 16.5V21.75C23.1406 23.7188 21.5547 25.25 19.6406 25.25H3.89062C1.92188 25.25 0.390625 23.7188 0.390625 21.75V6Z",
    fill: "#15A9AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.974b2c69024b260729f7dc46b66ff888.svg";
export { ForwardRef as ReactComponent };